import React, { Fragment, useEffect } from 'react';
import PowerSettingsNewOutlinedIcon from '@mui/icons-material/PowerSettingsNewOutlined';
import { Link, useNavigate } from 'react-router-dom';
import { logout, logoutCurrentUser, signOutFromCurrentDevice } from "../../../redux/actions/userAction";
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Loader/Loader';
import { useLogoutUserMutation } from '../../../redux/APIs/authApi';


function UserLogout() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {loading} = useSelector(
        (state) => state.user
      )

      const [logoutUser] = useLogoutUserMutation();

    const logoutUserHandler = async() => {

        await logoutUser()
    }


  return (
    <Fragment>
        {loading ? <Loader/> :
        <Fragment>
        <div  className='l_o_main' onClick={logoutUserHandler}>
            <div className='l_o_icon'><PowerSettingsNewOutlinedIcon fontSize='small' className='d_d_m_icons'/></div>
            <div ><span>Logout</span></div>
        </div>
        </Fragment>
        }
    </Fragment>
  )
}

export default UserLogout